import { TYPES } from './actions';
import { merge } from '../../../../utils/state';

const initialState = {
  registrantsData: {
    data: {},
    isLoading: false,
    isLoadingMore: false,
    error: null,
  },
  currentRegistrant: {},
  currentRegistrantResume: null,
  isCurrentRegistrantLoading: false,
  isCurrentRegistrantResumeLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.GET_REGISTRANTS_REQUEST:
      return merge(state, {
        registrantsData: merge(state.registrantsData, {
          error: null,
          isLoading: true,
        }),
      });
    case TYPES.GET_REGISTRANTS_SUCCESS:
      return merge(state, {
        registrantsData: merge(state.registrantsData, {
          data: action.payload.data,
          error: false,
          isLoading: false,
        }),
      });
    case TYPES.GET_REGISTRANTS_ERROR:
      return merge(state, {
        registrantsData: merge(state.registrantsData, {
          error: true,
          isLoading: false,
        }),
      });
    case TYPES.GET_MORE_REGISTRANTS_REQUEST:
      return merge(state, {
        registrantsData: merge(state.registrantsData, {
          error: null,
          isLoadingMore: true,
        }),
      });
    case TYPES.GET_MORE_REGISTRANTS_SUCCESS:
      return merge(state, {
        registrantsData: merge(state.registrantsData, {
          data: merge(state.registrantsData.data, {
            ...action.payload.data,
            content: [
              ...state.registrantsData.data.content,
              ...action.payload.data.content,
            ],
          }),
          error: false,
          isLoadingMore: false,
        }),
      });
    case TYPES.GET_MORE_REGISTRANTS_ERROR:
      return merge(state, {
        registrantsData: merge(state.registrantsData, {
          error: true,
          isLoadingMore: false,
        }),
      });
    case TYPES.GET_REGISTRANT_DETAILS_REQUEST:
      return merge(state, {
        error: null,
        isCurrentRegistrantLoading: true,
      });
    case TYPES.GET_REGISTRANT_DETAILS_SUCCESS:
      return merge(state, {
        currentRegistrant: action.payload.currentRegistrant,
        error: false,
        isCurrentRegistrantLoading: false,
      });
    case TYPES.GET_REGISTRANT_DETAILS_ERROR:
      return merge(state, {
        error: true,
        isCurrentRegistrantLoading: false,
      });
    case TYPES.GET_REGISTRANT_RESUME_REQUEST:
      return merge(state, {
        isCurrentRegistrantResumeLoading: true,
        error: null,
      });
    case TYPES.GET_REGISTRANT_RESUME_SUCCESS:
      return merge(state, {
        currentRegistrantResume: action.payload.resume,
        isCurrentRegistrantResumeLoading: false,
        error: false,
      });
    case TYPES.GET_REGISTRANT_RESUME_ERROR:
      return merge(state, {
        isCurrentRegistrantResumeLoading: false,
        error: true,
      });
    case TYPES.CLEAR_REGISTRANTS_LIST_STATE:
      return merge(state, {
        registrantsData: {
          data: {},
          isLoading: false,
          error: null,
        },
        error: false,
        isLoading: false,
      });
    case TYPES.CLEAR_CURRENT_REGISTRANT_STATE:
      return merge(state, {
        currentRegistrant: {},
        error: false,
        isLoading: false,
      });
    case TYPES.CLEAR_CURRENT_REGISTRANT_RESUME_STATE:
      return merge(state, {
        currentRegistrantResume: null,
        error: false,
        isLoading: false,
      });
    case TYPES.UPDATE_ATTENDANCE_STATUS_REQUEST:
      return merge(state, {
        error: null,
        isCurrentRegistrantLoading: true,
      });
    case TYPES.UPDATE_ATTENDANCE_STATUS_SUCCESS:
      return merge(state, {
        error: false,
        isCurrentRegistrantLoading: false,
      });
    case TYPES.UPDATE_ATTENDANCE_STATUS_FAILURE:
      return merge(state, {
        error: true,
        isCurrentRegistrantLoading: false,
      });
    case TYPES.CLEAR_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
